import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { registrarUsuarioAnonimo, guardarUbicacionHistorial } from "../api";

const Onboarding = () => {
    const [step, setStep] = useState(1);
    const navigate = useNavigate();
    const [checking, setChecking] = useState(true);

  useEffect(() => {
    const yaVisto = localStorage.getItem("onboarding_visto");
    if (yaVisto) {
      navigate("/home");
    } else {
      setChecking(false);
    }
  }, [navigate]);

  useEffect(() => {
    let anonId = localStorage.getItem("anon_id");
  
    if (!anonId) {
      anonId = uuidv4();
      localStorage.setItem("anon_id", anonId);
    }

    if (window.flutter_inappwebview) {
      window.flutter_inappwebview.callHandler('registrarDispositivo', {
        anon_id: anonId,
      });
    }
  
    registrarUsuarioAnonimo(anonId);
  }, []);  

  useEffect(() => {
    const getOS = () => {
      const ua = navigator.userAgent || "";
  
      if (/android/i.test(ua)) return "Android";
      if (/iPhone|iPad|iPod/i.test(ua)) return "iOS";
      return "Otro";
    };
  
    localStorage.setItem("os_device", getOS());
  }, []);  

  if (checking) return null;

  const finalizar = () => {
    localStorage.setItem("onboarding_visto", "true");
    navigate("/home");
  };

  const solicitarUbicacion = async () => {
    try {
      setStep(3);
      return;
    } catch (error) {
      setStep(3);
      localStorage.setItem("locationPermissionAsked", "true");
    }
  };  

  const solicitarNotificaciones = async () => {
    finalizar();
  };

  return (
    <div className="onboarding-container">
      {step === 1 && (
        <div className="onboarding-step">
          <img src="/assets/images/1.png" alt="Intro" style={{ display: "block", margin: "50px auto", maxWidth: "45%"}} />
          <h2>¡Hola! Qué placer tenerte por aquí 😊</h2>
          <p>Descubre los mejores lugares cerca de tí: restaurantes, tiendas, servicios y más. Explora, recomienda y conecta con comercios locales en un solo lugar. Todo a través de la App.</p>
          <button onClick={() => setStep(2)}>¡Comencemos!</button>
          <div className="onboarding-dots">
            <span className={step === 1 ? "dot active" : "dot"}></span>
            <span className={step === 2 ? "dot active" : "dot"}></span>
            <span className={step === 3 ? "dot active" : "dot"}></span>
            </div>
        </div>
      )}

      {step === 2 && (
        <div className="onboarding-step">
          <img src="/assets/images/2.png" alt="Intro" style={{ display: "block", margin: "50px auto", maxWidth: "45%"}} />
          <h2>Tu ubicación nos permite ayudarte mejor</h2>
          <p>Con este permiso, te mostramos resultados más relevantes según dónde te encuentres. Tus datos están seguros y se usan solo para mejorar tu experiencia.</p>
          <button onClick={solicitarUbicacion}>Continuar</button>
          <div className="onboarding-dots">
            <span className={step === 1 ? "dot active" : "dot"}></span>
            <span className={step === 2 ? "dot active" : "dot"}></span>
            <span className={step === 3 ? "dot active" : "dot"}></span>
            </div>
        </div>
      )}

      {step === 3 && (
        <div className="onboarding-step">
          <img src="/assets/images/4.png" alt="Intro" style={{ display: "block", margin: "50px auto", maxWidth: "45%"}} />
          <h2>Queremos mantenerte al día</h2>
          <p>Activa las notificaciones y enterate primero de promociones exclusivas, eventos especiales y novedades que te interesan. ¡No te lo pierdas!</p>
          <button onClick={solicitarNotificaciones}>Finalizar</button>
          <div className="onboarding-dots">
            <span className={step === 1 ? "dot active" : "dot"}></span>
            <span className={step === 2 ? "dot active" : "dot"}></span>
            <span className={step === 3 ? "dot active" : "dot"}></span>
            </div>

        </div>
      )}
    </div>
  );
};

export default Onboarding;